import { eMienGiamSoTienActionsObj } from "../../action-types/mien-giam/IMienGiamSoTienActions";
import { generateActions } from "../generateActions";

export const mienGiamSoTienActions = {
  ...generateActions(eMienGiamSoTienActionsObj, "MIEN_GIAM_SO_TIEN"),
};
